<template>
  <card class="no-border-card card-instructions">
    <template slot="header">
      <h3>Recipe Links</h3>
    </template>
    <div class="recipe-links  scrollbar-inner">
        <ul class="list-links">
            <li v-for="(link) in recipeData.recipeLinks" :key="link.id">
                
                <a :href='link.uri' target='_blank' class="font-weight-600 text-md text-capitalize">{{link.name}}</a>
                <p v-html="link.description"></p>
                <div v-html="formatEmbed(link)" v-on:click="pauseScroll" :class="scrollActive? 'scrolling' : ''" ></div>
                
            </li>
        </ul>
    </div>
  </card>
</template>
<script>
import getVideoId from 'get-video-id';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
        const container = document.querySelector( container.prop( "scrollHeight" ) );
      }, 100);
    }
  }

  export default {
    components: {
        getVideoId
    },
    title: "recipe-links",
    props: ['recipeData'],
    data() {
      return {
          scrollActive: false
      }
    },
    computed: {
    },
    methods: {
        onCreated() {
        },
        formatEmbed(link) {
            const videoId = getVideoId(link.uri);

            if ( videoId.service == 'youtube' ) {
                return `
                <div class='embed-container'>
                <iframe src="https://www.youtube.com/embed/${videoId.id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                `
            } else if ( videoId.service == 'vimeo' ) {
                const videoId = getVideoId(link.uri);
                return `
                <div class='embed-container'>
                <iframe src="https://player.vimeo.com/video/${videoId.id}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                </div>
                `
            } else {
                console.log('Format not found: ',videoId);
                return `
                `
            }
        },
        initScrollbar() {
            if (!this.scrollActive) {
                initScrollbar('recipe-links');
                this.scrollActive = true;
            }
        },
        pauseScroll() {
            this.scrollActive = false;
            setTimeout(() => {
                this.initScrollbar()
            }, 2400)
        }
    },
    created(){
      this.onCreated();
    },
    mounted() {
        let vimeoScript = document.createElement('script')
        vimeoScript.setAttribute('src', 'https://player.vimeo.com/api/player.js')
        document.head.appendChild(vimeoScript)
        this.initScrollbar();
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>

<style>
.recipe-links {
  height:400px;
  overflow:hidden;
  position:relative
}
</style>
